<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Accounting</div><h2>Bills in Buildium</h2></div>
        </div>
        <section class="page-section">
            <el-form :inline="true" size="medium">
                <el-form-item label="Vendor">
                    <el-input size="medium" class="w200" :clearable="true" v-model="params.vendor"/>
                </el-form-item>
                <el-form-item label="Reference Number">
                    <el-input size="medium" class="w200" :clearable="true" v-model="params.referencenumber"/>
                </el-form-item>
                <el-form-item label="Paid Status">
                    <el-select size="medium" v-model="params.paidstatus" placeholder="Status" clearable>
                        <el-option label="Paid" value="Paid"/>
                        <el-option label="Unpaid" value="Unpaid"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="Paid Date">
                    <el-date-picker
                        v-model="params.daterange"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="From"
                        end-placeholder="To"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="onSearch">Filter</el-button>
                </el-form-item>
            </el-form>
        </section>
        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="Id" label="ID" width="100"/>
                <el-table-column prop="vendor.name" label="Vendor"/>
                <el-table-column prop="PaidDate" label="Paid Date"/>
                <el-table-column prop="ReferenceNumber" label="Reference Number"/>
                <el-table-column label="Amount" width="100">
                    <template slot-scope="scope">
                        <div v-for="line in scope.row.Lines||[]">{{ '$' + line.Amount }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Memo">
                    <template slot-scope="scope">
                        <div v-for="line in scope.row.Lines||[]">{{ line.Memo }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" align="right" width="200">
                    <template slot-scope="scope">
                        <a class="el-link el-link--primary" @click="$refs.modalBillPayments.open(scope.row.Id)">
                            Payments
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-button type="primary" size="small" @click="batchDelete">{{
                            $t('common.batch_delete')
                        }}
                    </el-button>
                </div>
                <div class="flex"></div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
        <modal-bill-payments ref="modalBillPayments"/>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";
import ModalBillPayments from "./ModalBillPayments.vue";

export default {
    name: "Bills",
    components: {ModalBillPayments},
    mixins: [Pagination],
    data() {
        return {
            bulkAction: '',
            autoSearch: true,
            params: {
                vendor: '',
                referencenumber: '',
                paidstatus: '',
                daterange: []
            },
            pageSize: 20
        }
    },
    methods: {
        listApi() {
            return '/buildium/bills'
        },
        listParams() {
            return this.params;
        },
        batchDelete() {
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                this.loading = true;
                let ids = this.selectionIds.map((d) => d.Id);
                ApiService.delete('/buildium/bills/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                    this.$message.success('Vendors Deleted');
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        getFullName(vendor) {
            return (vendor?.FirstName || '') + ' ' + (vendor?.LastName || '');
        },
        onBulkAction() {
            switch (this.bulkAction) {
                case 'delete':
                    this.batchDelete();
                    break;
            }
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<style scoped>

</style>